import React from "react"
import { getSvgFill } from "utils"

const VeryActive = ({ isSelected }: { isSelected: boolean }) => {
  const { backgroundFill, pathFill } = getSvgFill(isSelected)
  const fillOpacity = isSelected ? 1 : 0.6
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <g clipPath="url(#clip0_9274_26401)">
        <path
          d="M20.1214 8.75011C19.3651 10.0564 19.8189 11.7476 21.1251 12.5039C22.4314 13.2601 24.1226 12.8064 24.8789 11.5001C25.6351 10.1939 25.1814 8.50261 23.8751 7.74636C22.5689 6.99011 20.8776 7.44386 20.1214 8.75011Z"
          fill={pathFill}
          fillOpacity={fillOpacity}
        />
        <path
          d="M22.2801 14.8139C22.2801 14.8139 20.0388 13.5214 18.7051 12.7514C15.7763 11.0464 14.5663 7.48511 15.7076 4.40511C15.9413 3.77261 15.6938 3.07136 15.1163 2.74136C14.3876 2.32886 13.4388 2.64511 13.1501 3.42886C11.8438 6.88011 12.6688 10.7851 15.1576 13.4251L8.76381 24.4939C8.37881 25.1539 8.61256 25.9926 9.27256 26.3776C9.93256 26.7626 10.7713 26.5289 11.1563 25.8689L12.5313 23.4901L14.9101 24.8651L11.4726 30.8189C11.0876 31.4789 11.3213 32.3176 11.9813 32.7026C12.6413 33.0876 13.4801 32.8539 13.8651 32.1939L21.8263 18.4164C23.1738 20.2589 23.5588 22.7064 22.7338 24.9064C22.5001 25.5251 22.7613 26.2264 23.3251 26.5564C24.0538 26.9826 25.0026 26.6664 25.3051 25.8689C26.6388 22.2664 25.8688 17.8389 22.2801 14.8139Z"
          fill={pathFill}
          fillOpacity={fillOpacity}
        />
        <path
          d="M18.0313 5.72501C19.0213 6.28876 20.2725 5.95876 20.85 4.96876C21.4138 3.97876 21.0838 2.72751 20.0938 2.15001C19.1038 1.58626 17.8525 1.91626 17.275 2.90626C16.7113 3.89626 17.0413 5.16126 18.0313 5.72501Z"
          fill={pathFill}
          fillOpacity={fillOpacity}
        />
      </g>
      <defs>
        <clipPath id="clip0_9274_26401">
          <rect
            width="33"
            height="33"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default VeryActive
